import { useEffect, useState } from "react";

import { getStatsTimeSeries, StatsPeriodFilter } from "services/stats/rest";
import { StatsIntervalDto, StatsTimeSeriesDto } from "services/stats/restModels";

export interface UseStatsTimeSeriesResult {
    series: StatsTimeSeriesDto | null;
    loading: boolean;
    error: boolean;
}

/*
* Ряд для графика. Грузится лениво — фильтр приходит непустым только после того, как график
* открыли: ряд нужен одной модалке, а запрос это агрегация по всем заказам периода.
*
* Все три метрики (заказы, выручка, средний чек) приходят в одном ответе, поэтому переключение
* метрики внутри модалки запроса не стоит.
* */
export const useStatsTimeSeries = (
    filter: StatsPeriodFilter | null,
    interval: StatsIntervalDto | null
): UseStatsTimeSeriesResult => {
    const [series, setSeries] = useState<StatsTimeSeriesDto | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);

    const menuId = filter === null ? null : filter.menuId;
    const from = filter === null ? null : filter.from;
    const to = filter === null ? null : filter.to;
    const intervalAmount = interval === null ? null : interval.amount;
    const intervalPeriod = interval === null ? null : interval.period;

    useEffect(() => {
        if (
            menuId === null ||
            from === null ||
            to === null ||
            intervalAmount === null ||
            intervalPeriod === null
        ) {
            setSeries(null);
            setLoading(false);
            return undefined;
        }

        let ignore = false;

        setLoading(true);
        setError(false);

        getStatsTimeSeries({ menuId, from, to }, { amount: intervalAmount, period: intervalPeriod })
            .then((result) => {
                if (ignore) return;
                if (result) {
                    setSeries(result);
                } else {
                    setError(true);
                    setSeries(null);
                }
            })
            .catch(() => {
                if (ignore) return;
                setError(true);
                setSeries(null);
            })
            .finally(() => {
                if (ignore) return;
                setLoading(false);
            });

        return () => {
            ignore = true;
        };
    }, [menuId, from, to, intervalAmount, intervalPeriod]);

    return { series, loading, error };
};
